import { render, staticRenderFns } from "./DiskMain.vue?vue&type=template&id=4834e966&scoped=true&"
import script from "./DiskMain.vue?vue&type=script&lang=js&"
export * from "./DiskMain.vue?vue&type=script&lang=js&"
import style0 from "./DiskMain.vue?vue&type=style&index=0&id=4834e966&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834e966",
  null
  
)

export default component.exports